module.exports = __webpack_public_path__ + "static/media/Saudagar.966095a7.ttf";